// extracted by mini-css-extract-plugin
export default {"root":"src__modules__common__edit-entry-data__root","title":"src__modules__common__edit-entry-data__title"};